module.exports = __webpack_public_path__ + "img/aftereffects.8adfbe0d.png";